import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';
import { MOBILE_BREAKPOINT, flexCenter, baseButton, menuItem } from '../Header.style';

export const Overlay = styled.div`
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition: all 0.3s ease;

  @media (max-width: ${MOBILE_BREAKPOINT}) { display: block; }
`;

export const Menu = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 280px;
  max-width: 85vw;
  background: ${white};
  z-index: 1002;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  transform: ${({ $isOpen }) => ($isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAKPOINT}) { display: flex; }
`;

export const MenuHeader = styled.div`
  ${flexCenter}
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${neutral[200]};
  background: ${neutral[50]};
`;

export const MenuTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${neutral[900]};
`;

export const MenuClose = styled.button`
  ${baseButton}
  padding: 8px;
  color: ${neutral[500]};
  border-radius: 8px;

  &:hover {
    background: ${neutral[100]};
    color: ${neutral[900]};
  }

  i {
    font-size: 24px;
    display: block;
  }
`;

export const MenuNav = styled.nav`
  padding: 16px 0;
  border-bottom: 1px solid ${neutral[200]};
`;

export const NavItem = styled.button`
  ${baseButton}
  ${flexCenter}
  width: 100%;
  gap: 12px;
  padding: 14px 20px;
  background: ${({ $active }) => ($active ? rgba(primary[500], 0.08) : 'transparent')};
  border-left: 3px solid ${({ $active }) => ($active ? primary[500] : 'transparent')};
  color: ${({ $active }) => ($active ? primary[600] : neutral[700])};
  font-size: 15px;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};

  &:hover {
    background: ${neutral[50]};
    color: ${neutral[900]};
  }

  i { font-size: 20px; }
`;

export const Badge = styled.span`
  background: ${primary[500]};
  color: ${white};
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: auto;
`;

export const UserSection = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid ${neutral[200]};
`;

export const UserInfo = styled.div`
  ${flexCenter}
  gap: 12px;
  margin-bottom: 12px;

  i {
    font-size: 32px;
    color: ${primary[500]};
  }
`;

export const UserDetails = styled.div`
  flex: 1;
  min-width: 0;
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${neutral[900]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserEmail = styled.div`
  font-size: 12px;
  color: ${neutral[500]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AdminSection = styled.div`
  padding: 8px 0;
`;

export const AdminItem = styled.button`
  ${menuItem}
`;

export const LogoutButton = styled.button`
  ${baseButton}
  ${flexCenter}
  justify-content: center;
  gap: 10px;
  width: calc(100% - 40px);
  padding: 14px 20px;
  margin: 16px 20px;
  border: 1px solid ${primary[500]};
  border-radius: 10px;
  color: ${primary[500]};
  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: ${primary[500]};
    color: ${white};
  }

  i { font-size: 18px; }
`;
